<template>
    <div class="container">
        <button class="back-button" @click="goBack">返回上一页</button>
        <h1>设备信息</h1>

        <div class="model-selector">
            <label>按设备名称筛选：</label>
            <select v-model="selectedName" @change="filterDevices">
                <option value="">全部</option>
                <option v-for="name in uniqueNames" :key="name" :value="name">{{ name }}</option>
            </select>

           <label style="margin-left: 20px;">按设备型号筛选：</label>
            <select v-model="selectedModel" @change="filterDevices">
                <option value="">全部</option>
                <option v-for="model in uniqueModels" :key="model" :value="model">{{ model }}</option>
            </select>
        </div>

        <div class="device-info-page">
            <div class="device-list">
                <DeviceInfoCard v-for="device in devices" :key="device.device_id" :time="device.timestamp"
                    :id="device.device_id" @click="selectDevice(device)" />
            </div>
            <div class="device-details">
                <div v-if="selectedDevice">
                    <h2>设备详细信息</h2>
                    <p><strong>设备 ID:</strong> {{ selectedDevice.device_id }}</p>
                    <p><strong>上次登录时间:</strong> {{ selectedDevice.timestamp }}</p>
                    <p><strong>设备名称:</strong> {{ selectedDevice.name }}</p> <!-- 新增 -->
                    <p><strong>设备型号:</strong> {{ selectedDevice.model }}</p> <!-- 新增 -->
                    <p><strong>位置:</strong> {{ selectedDevice.location.address }}</p>
                    <p><strong>纬度:</strong> {{ selectedDevice.latitude }}</p>
                    <p><strong>经度:</strong> {{ selectedDevice.longitude }}</p>
                    <p><strong>最新存储记录创建时间:</strong> {{ selectedDevice.created_at }}</p>
                    <hr>

                    <!-- 修改设备项目按钮 -->
                    <button @click="openEditModal" class="edit-btn">修改设备项目</button>

                    <!-- 弹窗组件 -->
                    <EditDeviceProjectModal
                    v-if="showModal"
                    :deviceId="selectedDevice.device_id"
                    :projects="projects"
                    :allProjects="allProjects"
                    @save="handleSave"
                    @close="showModal = false"
                    />

                    <div class="detail-files">
                        <label><strong>设备文件列表:</strong></label>
                        <div class="search-pagination">
                            <input type="text" v-model="fileSearch" placeholder="过滤文件" @input="filterFiles" />
                        </div>
                        <div class="file-list">
                            <div class="file-list-container">
                                <span><strong>log</strong></span>
                                <ul>
                                    <li v-for="file in filteredFiles.log" :key="file.name">
                                        <a :href="`/device-files/${selectedDevice.device_id}/log/${file}`" target="_blank">{{ file }}</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="file-list-container">
                                <span><strong>xlsx</strong></span>
                                <ul>
                                    <li v-for="file in filteredFiles.xlsx" :key="file.name">
                                        <a :href="`/device-files/${selectedDevice.device_id}/xlsx/${file}`" target="_blank">{{ file }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p>点击左侧的设备列表显示详细信息</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { transformDate } from '../utils';
import DeviceInfoCard from './DeviceInfoCard.vue';
import FileTree from './FileTree.vue';
import EditDeviceProjectModal from "./EditDeviceProjectModal.vue";
import projectList from "@/assets/json/laboratory_projects.json";
import { showSuccess,showError,showInfo, showWarning } from '../utils';

const axiosInstance = axios.create({
    baseURL: 'https://relia-server.com:3000',
    timeout: 10000,
    withCredentials: true
});

export default {
    name: 'DeviceInfo',
    components: {
        DeviceInfoCard,
        FileTree,
        EditDeviceProjectModal
    },
    data() {
        return {
            showModal: false,         // 控制编辑框显示
            projects: [],             // 已经配置好的项目列表
            allProjects: projectList, // 所有项目列表
            originalDevices: [], // 新增用于存储原始设备数据
            devices: [],         // 当前显示的设备列表
            selectedName: '',
            selectedModel: '',
            selectedDevice: null,
            fileSearch: '',
            filteredFiles: [],
            deviceList: [
                { name: "免疫荧光检测仪", model: "TZ-301" },
                { name: "免疫荧光检测仪", model: "TZ-302" },
                { name: "干式荧光免疫分析仪", model: "TZ-310" },
                { name: "免疫分析仪", model: "TZ-212" },
                { name: "胶体金试纸分析仪", model: "TZ-206" },
                { name: "胶体金试纸分析仪", model: "TZ-21" },
                { name: "干式荧光免疫分析仪", model: "TZ-320" },
                { name: "干式荧光免疫分析仪", model: "TZ-3000" },
                { name: "干式荧光免疫分析仪", model: "TZ-3000Plus" },
                { name: "干式荧光免疫分析仪", model: "TZ-33" },
                { name: "试剂卡孵育器", model: "FY-100" },
                { name: "全自动化学发光分析仪", model: "S600" },
                { name: "全自动血型分析仪", model: "BA6400" }
            ],
        };
    },
    async mounted() {
        try {
            // 1. 获取设备基础状态
            const stateRes = await axiosInstance.get('/api/device_state');
            const baseDevices = stateRes.data.map(transformDate);

            // 2. 并行获取所有设备的详细信息
            const detailRequests = baseDevices.map(device => 
                this.getDeviceInfo(device.device_id)
            );
            const details = await Promise.all(detailRequests);

            // 3. 合并数据
            this.originalDevices = baseDevices.map((device, index) => ({
                ...device,
                name: details[index].name || '未知设备',
                model: details[index].model || '未知型号'
            }));

            // 4. 初始化显示列表
            this.devices = [...this.originalDevices];
        }catch(error){
            console.error('Error fetching device state:', error);
        }
    },
    methods: {
        openEditModal: async function () {
            console.log("按钮被点击了");

            try {
                const device_id = this.selectedDevice.device_id;
                // 发送请求，获取设备配置
                const response = await axiosInstance.get(`/api/device-config/${device_id}`);
                
                // 解构获取返回的设备信息
                const { deviceId, projects } = response.data;

                // 更新本地 projects 数据
                this.projects = projects;

                // 打开弹窗
                this.showModal = true;
            } catch (error) {
                showError("无法获取设备配置");
            }
        },
        handleSave(payload) {
            console.log("保存的数据：", payload.projects);
            this.projects = payload.projects;

            axiosInstance.post('/api/save-device-config', {
                device_id: payload.device_id,   // 直接传递 device_id
                projects: payload.projects      // 直接传递 projects
            }).then(() => {
                showSuccess("保存设备项目成功");
            }).catch((err) => {
                showError("保存设备项目失败");
            });

            // 关闭弹窗
            this.showModal = false;
        },
        async selectDevice(device) {
            const device_info = await this.getDeviceInfo(device.device_id)
            console.log(`设备详细信息: ${device_info.name} ${device_info.model}`);
            
            // 更新设备列表中的设备信息
            const updatedDevice = {
                ...device,
                name: device_info.name,
                model: device_info.model
            };

            console.log("selectedDevice: {}",this.selectedDevice);

            // 更新原始设备和当前设备列表
            this.originalDevices = this.originalDevices.map(d => 
                d.device_id === device.device_id ? updatedDevice : d
            );
            this.devices = this.devices.map(d => 
                d.device_id === device.device_id ? updatedDevice : d
            );

            this.selectedDevice = updatedDevice;
            
            // 更新文件列表
            this.filteredFiles = updatedDevice.files;
        },
        goBack() {
            this.$router.go(-1);
        },
        filterFiles() {
            const search = this.fileSearch.toLowerCase();
            this.filteredFiles = {
                log: this.selectedDevice.files.log.filter((file) => file.toLowerCase().includes(search)),
                xlsx: this.selectedDevice.files.xlsx.filter((file) => file.toLowerCase().includes(search))
            }
        },
        async getDeviceInfo(device_id) {
            try {
                const res = await axiosInstance.get('/api/device_info', { params: { device_id } });
                return { 
                    success: true,
                    name: res.data.name || '未知设备', 
                    model: res.data.model || '未知型号' 
                };
            } catch (error) {
                console.error(`获取设备 ${device_id} 信息失败:`, error);
                return { success: false, name: '未知设备', model: '未知型号' };
            }
        },
        filterDevices() {
            this.devices = this.originalDevices.filter(device => {
                const matchesName = this.selectedName 
                    ? device.name === this.selectedName
                    : true;
                const matchesModel = this.selectedModel 
                    ? device.model === this.selectedModel
                    : true;
                return matchesName && matchesModel;
            });
        }
    },
    computed: {
        uniqueNames() {
            return [...new Set(this.originalDevices.map(d => d.name))];
        },
        uniqueModels() {
            return [...new Set(this.originalDevices.map(d => d.model))];
        }
    }

}
</script>

<style scoped>
.container {
    margin: 0 auto;
    max-width: 1200px;
    position: relative;
}

.device-info-page {
    margin: 0 auto;
    display: flex;
    max-width: 1000px;
    padding: 20px;
}

.device-list {
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 80vh;
    overflow-y: auto;
}

.device-details {
    width: 70%;
    padding-left: 20px;
    border-left: 1px solid #ccc;
}

.device-info-card {
    cursor: pointer;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f9f9f9;
    transition: background-color 0.3s;
}

.device-info-card:hover {
    background-color: #e9e9e9;
}

.file-list {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 10px;
  width: 100%;           /* 关键：撑满父容器宽度 */
  box-sizing: border-box;
}

.file-list-container {
  min-width: 150px;
  text-align: center;
}

.detail-files ul {
    list-style-type: none;
    padding: 0;
}

.detail-files li {
    margin-bottom: 5px;
}

.detail-files a {
    color: #1a73e8;
    text-decoration: none;
}

.detail-files a:hover {
    text-decoration: underline;
}

.search-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}

.file-tree-container {
    max-height: 400px;
    overflow-y: auto;
    margin-top: 10px;
}

.back-button {
    position: absolute;
    top: 20px;
    left: 20px;
    padding: 10px 20px;
    background-color: #3a3e6b;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.back-button:hover {
    background-color: #2a2e5b;
}

.model-selector {
    margin-bottom: 20px;
}

.model-selector label {
    font-size: 18px;
    margin-right: 10px;
}

.model-selector select {
    font-size: 18px;       /* 字号更大 */
    padding: 8px 12px;     /* 增加框大小 */
    min-width: 220px;      /* 最小宽度 */
    margin-right: 20px;
    border-radius: 6px;
    border: 1px solid #ccc;
}

/* 编辑框的背景遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 编辑框样式 */
.modal {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  max-width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.modal input {
  width: 100%;
  padding: 8px;
  margin: 10px 0;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.edit-btn, .save-btn, .cancel-btn {
  background-color: #4CAF50;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  margin-top: 15px;   /* 上方间距 */
  margin-bottom: 15px; /* 下方间距 */
}

.edit-btn {
  background-color: #007BFF;
}

.cancel-btn {
  background-color: #FF5722;
  margin-left: 10px;
}

.save-btn:hover, .cancel-btn:hover, .edit-btn:hover {
  background-color: #3e8e41;
}
</style>
